import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ExitPromptType } from '@frame/ui-components/exit-prompt'
import { VerificationMethodCard } from '@frame/ui-components/verification-method-card'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'

import { TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { useHeaderTitle } from '@frame/lib/hooks/useHeaderTitle'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { useVerifyViaDocuments } from '@frame/lib/hooks/useVerifyViaDocuments'
import { routes } from '@frame/routes'
import { DataAttribute } from '@frame/types'

export function SelectVerificationMethod() {
  const task = useDirectTask()
  const { bilEnabledStrategiesNoBank } = useStrategies()
  const verifyViaDocuments = useVerifyViaDocuments()
  const showExitPrompt = useShowExitPrompt()
  const title = useHeaderTitle()
  const [isLoading, setIsLoading] = useState({
    [TrueworkJsStrategy.CREDENTIALS]: false,
    [TrueworkJsStrategy.DOCUMENTS]: false,
    [TrueworkJsStrategy.BANK]: false,
    [TrueworkJsStrategy.EMPLOYMENT_STRATEGIES]: false,
    [TrueworkJsStrategy.INSTANT]: false,
    [TrueworkJsStrategy.SMART_OUTREACH]: false,
    [TrueworkJsStrategy.IRS]: false,
  })
  const navigate = useNavigate()

  function handleClick(strategy: TrueworkJsStrategy) {
    setIsLoading((prev) => ({ ...prev, [strategy]: true }))

    if (!task) {
      throw new Error('No tasks found')
    }

    switch (strategy) {
      case TrueworkJsStrategy.CREDENTIALS:
        if (task?.id) {
          const params = new URLSearchParams()
          params.set('q', task?.employer_name || '')
          navigate(`${routes.companySearch}/${task?.id}?${params.toString()}`)
        } else {
          navigate(routes.companySearch)
        }
        return null
      case TrueworkJsStrategy.DOCUMENTS:
        return verifyViaDocuments(task)
      default:
        return null
    }
  }

  return (
    <>
      <WidgetHeaderWithNavigation
        title={title}
        showExitPrompt={showExitPrompt}
        exitPromptType={ExitPromptType.EMPLOYER}
      />
      <Body
        data-cy={DataAttribute.POS_SCREEN_SELECT_VERIFICATION_METHOD}
        paddingTopOverride={0}
        className="grid space-y-2 p-5"
      >
        {bilEnabledStrategiesNoBank.map((strategy, idx) => {
          return (
            <VerificationMethodCard
              key={idx}
              intent={idx === 0 ? 'primary' : 'secondary'}
              strategy={strategy}
              onClick={() => handleClick(strategy)}
              disabled={Object.values(isLoading).some(Boolean)}
              loading={isLoading[strategy]}
            />
          )
        })}
      </Body>
    </>
  )
}
